<template>
  <div id="login"></div>
</template>

<script>
import { getToken, getUrlParam } from '@utils'
export default {
  name: '',
  props: {},
  data() {
    return {}
  },
  created() {
    // 复制链接跳转详情页
    // 在此页面走登陆流程直接跳转详情页
    // if (getToken()) {
    if (getUrlParam('type') == 1) {
      this.$router.push({
        path: '/active/details',
        query: {
          id: getUrlParam('id')
        }
      })
    } else if (getUrlParam('type') == 2) {
      this.$router.push({
        path: '/live/liveDetails',
        query: {
          id: getUrlParam('id'),
          type: 2
        }
      })
    }
    // }
  },
  mounted() {},
  watch: {},
  methods: {},
  components: {}
}
</script>

<style lang="scss" scoped></style>
